const deleteConditionModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/conditions/delete-condition-modal/delete-condition-modal.html',
  controller: 'DeleteConditionModalController',
};

angular
  .module('pis-tool.module')
  .component('deleteConditionModal', deleteConditionModal);
